import moment from 'moment';

export default Vue => {
    Vue.filter('dateTime', (date) => {
        if (!date) {
            return '-';
        }

        return moment(date).format('YYYY-MM-DD HH:mm:SS');
    });

    Vue.filter('numberWithComma', number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
};